import React from "react";
import SeoManager from "../SeoManager";

export default function InfoPage({ eyebrow, title, intro, sections = [], contactCard = null, highlights = [], path = "/" }) {
  return (
    <div className="content-page">
      <SeoManager
        title={title}
        description={intro}
        path={path}
        type="article"
      />
      <section className="content-hero">
        <p className="category-section__eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{intro}</p>
        {highlights.length > 0 && (
          <div className="content-highlights">
            {highlights.map((item) => (
              <div key={item.label} className="content-highlight-card">
                <span className="content-highlight-card__value">{item.value}</span>
                <span className="content-highlight-card__label">{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="content-layout">
        <div className="content-main">
          {sections.map((section) => (
            <article key={section.heading} className="content-card">
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.list && (
                <ul className="content-list">
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </div>

        {contactCard && (
          <aside className="content-side-card">
            <h3>{contactCard.title}</h3>
            {contactCard.lines.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </aside>
        )}
      </section>
    </div>
  );
}
